// extracted by mini-css-extract-plugin
export default {"zoomControls":"A--z","zoomControlButton":"B--z","zoomBanner":"C--z","bannerButton":"D--z","imageButton":"E--z","zoom":"F--z","zoomContent":"G--z"};